import { render, staticRenderFns } from "./role.vue?vue&type=template&id=d5c96f92&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"
import style0 from "./role.vue?vue&type=style&index=0&id=d5c96f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c96f92",
  null
  
)

export default component.exports